import React, { useContext } from 'react';
import ThemeContext from './ThemeContext';
export default function useThemeFactory(aesthetic) {
  return function useTheme() {
    var themeName = useContext(ThemeContext);
    return aesthetic.getTheme(themeName);
  };
}